import axios from "axios";
import { API_BASE } from "@/lib/api";

// Dedicated axios instance for the Salon (venue) portal — separate token.
export const VENUE_TOKEN_KEY = "fotuber_venue_token";

export const venueApi = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

venueApi.interceptors.request.use((config) => {
  const t = localStorage.getItem(VENUE_TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function setVenueToken(t) {
  if (t) localStorage.setItem(VENUE_TOKEN_KEY, t);
}
export const fmtTL = (v) => `${Number(v || 0).toLocaleString("tr-TR", { maximumFractionDigits: 2 })} ₺`;

export async function downloadVenueFile(path, filename) {
  const res = await venueApi.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export async function uploadVenueImage(file) {
  const fd = new FormData(); fd.append("file", file);
  const { data } = await venueApi.post("/venue/upload", fd);
  return `${process.env.REACT_APP_BACKEND_URL}${data.url}`;
}

export function clearVenueToken() {
  localStorage.removeItem(VENUE_TOKEN_KEY);
}
